import { EDOCSIGNPROVIDER_TOKEN } from 'utils/constants'
import { EServiceOrigin } from 'utils/catalogsApi/constants'
import { getCompanyFromLocalStorage, getLangFromLocalStorage } from 'utils/misc'
import { TActivityPermission } from 'shared/components/ActivitiesPermissionsBasedAccessValidator/interface'
import { TPaymentsApiVersion } from 'utils/interface'

export const API_HEADER_CONTENT_TYPE = {
  acceptLanguage: () => ({ 'accept-language': getLangFromLocalStorage() }),
  activityPermission: {
    getFromValue: (activityPermission: TActivityPermission) => ({ activitypermission: activityPermission })
  },
  apiVersion: (version: TPaymentsApiVersion) => ({ ApiVersion: version }),
  auth: {
    bearer: (token?: string) => ({ Authorization: `Bearer ${token}` })
  },
  companyId: {
    getFromLocalStorage: { CompanyId: getCompanyFromLocalStorage().entityId || '' },
    getFromValue: (id: string) => ({ CompanyId: id })
  },
  eDocSignProviderApiToken: { 'sora-token-api': EDOCSIGNPROVIDER_TOKEN },
  entityId: {
    getFromLocalStorage: () => ({ EntityId: getCompanyFromLocalStorage().entityId || '' }),
    getFromValue: (id = '') => ({ EntityId: id })
  },
  idempotencyKey: { getFromValue: (id?: string) => ({ IdempotencyKey: id }) },
  json: { 'Content-Type': 'application/json' },
  liveMode: {
    getFromTestMode: (testMode?: boolean) => ({ liveMode: testMode === undefined ? undefined : `${!testMode}` })
  },
  multipartFormData: { 'Content-Type': 'multipart/form-data' },
  serviceOrigin: {
    getFromValue: (origin: EServiceOrigin) => ({ ServiceOrigin: origin })
  },
  userId: { getFromValue: (id?: string) => ({ UserId: id }) }
}

export const API_PAYLOAD_CONTENT_TYPE = {
  origin: { origin: 'Panel' }
}
export const FINGERPRINT_HASH_SEED = 31
export const REQUEST_RETRIES_DEFAULT = 0
export const REQUEST_RETRIES_DOUBLE = 2

export enum FormatReport {
  CSV = 'csv',
  EXCEL = 'excel'
}

export enum TypeReport {
  RPT_CHARGES = 'rpt_charges',
  RPT_ORDERS = 'rpt-orders',
  RPT_TRANSFER_DETAIL = 'rpt_transfer_detail',
  RPT_INVOICE_DETAIL = 'rpt_invoice_detail'
}

export enum ERuleConditionConditional {
  AND = 'and',
  OR = 'or'
}

export enum ERuleConditionFieldData {
  FLOAT64 = 'float64',
  STRING = 'string',
  INT = 'int',
  BOOL = 'bool'
}

export enum ERuleConditionOperator {
  CONTAINS = 'co',
  EW = 'ew',
  IN = 'in',
  SW = 'sw',
  DISTINCT = '!=',
  EQUAL = '==',
  GREATER = '>',
  EQUAL_OR_GREATER = '>=',
  LESS = '<',
  IQUAL_OR_LESS = '<='
}

export enum ESmartRetryType {
  PAID = 'paid',
  REJECTED = 'rejected'
}
